import { render, staticRenderFns } from "./card-management.vue?vue&type=template&id=df0773f6&scoped=true"
import script from "./card-management.vue?vue&type=script&lang=js"
export * from "./card-management.vue?vue&type=script&lang=js"
import style0 from "./card-management.vue?vue&type=style&index=0&id=df0773f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0773f6",
  null
  
)

export default component.exports